import { useQuery } from '@tanstack/react-query'
import { isRevisit } from '@lib/helpers/site-record'
import { siteVisitKeys } from '@/hooks/queryKeys'
import { siteVisitService } from '@/services/SiteVisitService'
import { todayLocal } from '@/site-visits/visitStore'

/**
 * Whether a change to a site's outline or areas, made at a desk today, is
 * made on a revisit, and so asks "Changed, or drawn wrong?" on its save
 * (docs/site-visits.md). Not until the site's visits have loaded: a desk
 * edit asks nothing it cannot answer for.
 */
export function useSiteRecordRevisit(siteId: string): boolean {
  const query = useQuery({
    queryKey: siteVisitKeys.list(siteId),
    queryFn: () => siteVisitService.list(siteId),
    enabled: siteId !== '',
    staleTime: 30_000,
  })
  return isRevisit(query.data?.visits ?? [], 'site', todayLocal())
}
